const path = 'wallet-refills';

export default [
  {
    path: path,
    name: 'wallet-refills',
    component: () => import('@views/wallet-refills/Index'),
  },
];
